import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useTabContentContext } from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Context';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import OutcomeGroup
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/Summary/OutcomeGroups/OutcomeGroup';
import metaOverrides from '../MetaOverrides';

const useStyles = buildUseStyles('OutcomeGroups', (() => ({
  root: {},
  summaryCardMetaForm: {
    padding: 0,
  },
})));

const Styleless = ({ className, ...props }) => <Box {...props} />;

const OutcomeGroups = ({ className }) => {
  const classes = useStyles();
  const { activeTabResource } = useTabContentContext();
  const hasOutcomeGroups = Boolean(activeTabResource?.attr('outcomeGroups')?.resources().list().length > 0);

  if (!hasOutcomeGroups) {
    return null;
  }

  return (
    <Box className={classNames(classes.root, className)}>
      <MetaCollectionFormInline
        className={classes.summaryCardMetaForm}
        collection={activeTabResource?.attr('outcomeGroups')}
        FormProps={{
          component: Styleless,
          layout: OutcomeGroup,
          noIndividualSubmitButtons: true,
        }}
        metaOverrideSet={metaOverrides}
      />
    </Box>
  );
};

OutcomeGroups.defaultProps = {
  className: '',
};

OutcomeGroups.propTypes = {
  className: PropTypes.string,
};

export default OutcomeGroups;
